var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 15.5V17.5H18.5V15.5H2.5ZM2.5 10.5V12.5H14.5V10.5H2.5ZM2.5 5.5V7.5H20.5V5.5H2.5Z",
    fill: "#445386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumburgerIcon);
export default __webpack_public_path__ + "static/media/humburgerIcon.33345d12f8d417743ead7cc04bb52796.svg";
export { ForwardRef as ReactComponent };